export default __webpack_public_path__ + "static/media/face.d3fc13eb.svg";